import LanguageService from '@/core/services/language';
import ModuleTypeService from '@/core/services/moduleType';
import PageTypeService from '@/core/services/pageType';
import VisitorService from '@/core/services/visitor';
import city from '@/core/stores/city.store';
import journeyModule from '@/modules/journeys/store';
import { createStore } from 'vuex';
const languageService = new LanguageService();
const moduleTypeService = new ModuleTypeService();
const pageTypeService = new PageTypeService();
const visitorService = new VisitorService();

export default createStore({
   modules: {
      journeyModule,
      city,
   },

   state: {
      languages: [],
      moduleTypes: [],
      notifications: [],
      pageTypes: [],
      missingRegistrationFields: [],
   },
   getters: {
      missingRegistrationFields: (state) => {
         return state.missingRegistrationFields;
      },
   },
   mutations: {
      pushNotification(state: any, notification) {
         state.notifications.push(notification);
      },
      removeNotification(state: any, notificationToRemove) {
         state.notifications = state.notifications.filter((notification: any) => {
            return notification.id != notificationToRemove.id;
         });
      },
      setMissingRegistrationFields(state, fields) {
         state.missingRegistrationFields = fields || [];
      },
      clearMissingRegistrationFields(state) {
         state.missingRegistrationFields = [];
      },
   },
   actions: {
      async getLanguages(context) {
         return await languageService.getLanguages().then((response: any) => {
            context.state.languages = response.data;
            return response;
         });
      },

      async getModuleTypes(context) {
         await moduleTypeService.getModuleTypes().then((response) => {
            context.state.moduleTypes = response;
         });
      },
      async getPageTypes(context) {
         await pageTypeService.getPageTypes().then((response) => {
            context.state.pageTypes = response;
         });
      },
      async addNotification(context, { notification }) {
         let newNotification = {
            ...notification,
            duration: notification.duration ? notification.duration : 5000,
            id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
         };
         context.commit('pushNotification', newNotification);
         return newNotification;
      },
      async removeNotification(context, { notification }) {
         context.commit('removeNotification', notification);
      },
      async registerVisitor(context, { page_type_key, referral_id }: { page_type_key: 'landing' | 'registration'; referral_id: Number }) {
         return await visitorService.postVisitor(page_type_key, referral_id).then((response) => {
            return response;
         });
      },
   },
});

